import React from "react";

/**
 * Sep 2026 Phase 22n — Shared highlight helper.
 * Bungkus substring cocok dengan `<mark className="bg-[#FEF08A]">`.
 * Case-insensitive. Aman terhadap karakter regex (pakai plain indexOf).
 * Menerima query yang belum di-normalize; membersihkan whitespace sendiri.
 * Bila query kosong atau tidak ditemukan, kembalikan text asli.
 */
export function highlightMatch(text, query) {
  if (!query || !text) return text || "";
  const q = String(query).trim();
  if (!q) return text;
  const src = String(text);
  const idx = src.toLowerCase().indexOf(q.toLowerCase());
  if (idx < 0) return src;
  return (
    <>
      {src.slice(0, idx)}
      <mark className="bg-[#FEF08A] text-[#111827] rounded-sm px-0.5">
        {src.slice(idx, idx + q.length)}
      </mark>
      {src.slice(idx + q.length)}
    </>
  );
}
